import {Component, Input, OnInit} from '@angular/core';
import {EventService} from "../../core/services/event.service";

declare var ENVIRONMENT_CONFIG: any;

@Component({
  selector: 'help-frame',
  template: `
  <nav class="cat__core__top-sidebar cat__core__top-sidebar--bg">
    <span class="cat__core__title d-block mt-2 mb-2"><strong>Help</strong></span>
  </nav>
  <div><iframe [src]="page?.fullUrl | safe" class="help-preview page-preview" name="pagepreview"></iframe></div>`
})
export class HelpFrameComponent implements OnInit {

  @Input() public page: any = {};

  constructor(public eventService: EventService) {}

  ngOnInit() {
    var help_url = this.eventService.selectedEvent.gql.Participant[0].event.program.programGroup.fundraisingToolsHelpUrl;
    this.page.fullUrl = ENVIRONMENT_CONFIG.fundraiseUrl + help_url;
  }
}
